import { DebugProtocol } from 'vscode-debugprotocol';

export type DebuggerFileExtension = '4dm' | '4qs';

export enum SourceCodeDescriptor {
  METHOD = 1,
  CLASS = 10,
}

export interface ICodeDescriptor {
  type: number;
  methodName?: string;
  className?: string;
  functionName?: string;
  methodPath?: string;
}

export interface ISource extends DebugProtocol.Source {
  codeDescriptor?: ICodeDescriptor;
  codeDescriptorInfo?: ICodeDescriptor;
}
